<template>
  <input
    v-if="fieldGroup"
    :class="inputGroupClasses"
    :autofocus="autofocus"
    :name="name"
    :value="value"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :disabled="disabled"
    :readonly="readonly"
    :type="type"
    :pattern="pattern"
    @focus="handleOnFocus"
    @blur="handleOnBlur"
    @input="onInput"
    @keyup.enter="onEnterKey"
  />
  <b-field v-else :label="label" :message="validationMessage">
    <b-input
      class="academy-input"
      :autofocus="autofocus"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :disabled="disabled"
      :loading="loading"
      :size="size"
      :icon="icon"
      :readonly="readonly"
      :rounded="rounded"
      :type="type"
      @input="handleOnChange"
      @keypress.native="handleNativeKeyPress"
      @keyup.enter="onEnterKey"
    ></b-input>
  </b-field>
</template>

<script>
import cn from 'classnames'
export default {
  name: 'AcademyTextInput',
  props: {
    fieldGroup: {
      type: Boolean,
      default() {
        return false
      },
    },
    value: {
      type: [String, Number],
      default() {
        return ''
      },
    },
    name: {
      type: String,
      default() {
        return ''
      },
    },
    label: {
      type: String,
      default() {
        return ''
      },
    },
    type: {
      type: String,
      default() {
        return ''
      },
    },
    size: {
      type: String,
      default() {
        return ''
      },
    },
    placeholder: {
      type: String,
      default() {
        return ''
      },
    },
    icon: {
      type: String,
      default() {
        return ''
      },
    },
    passwordReveal: {
      type: Boolean,
      default() {
        return false
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false
      },
    },
    rounded: {
      type: Boolean,
      default() {
        return false
      },
    },
    autofocus: {
      type: Boolean,
      default() {
        return false
      },
    },
    maxlength: {
      type: [String, Number],
      default() {
        return ''
      },
    },
    validationMessage: {
      type: String,
      default() {
        return ''
      },
    },
    pattern: {
      type: String,
      default() {
        return ''
      },
    },
    onChange: {
      type: Function,
      default() {
        return () => {}
      },
    },
    onEnterKey: {
      type: Function,
      default() {
        return () => {}
      },
    },
    maxWord: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isFocused: this.autofocus,
    }
  },
  computed: {
    isNotEmptyValue() {
      return ![null, undefined].includes(this.value) && this.value.toString().trim().length > 0
    },
    inputGroupClasses() {
      return cn({
        [`academy-input academy-input--in-group input Components__Form__TextInput-${this.name}`]: true,
        'academy-input--focused': this.isFocused,
        'academy-input--not-empty': this.isNotEmptyValue,
      })
    },
  },
  methods: {
    onInput(event) {
      this.onChange(event)
      this.$emit('input', event.target.value)
    },
    handleOnChange(value) {
      if (this.name) {
        this.onChange({ name: this.name, value })
      } else {
        this.onChange(value)
      }
    },
    handleOnFocus() {
      this.isFocused = true
    },
    handleOnBlur() {
      this.isFocused = false
    },
    handleNativeKeyPress(event) {
      if (this.maxWord && this.value.split(' ').length > this.maxWord) {
        event.preventDefault()
      }
    },
  },
}
</script>

<style lang="scss">
.academy-input {
  display: inline-flex;
  width: 100%;
  input {
    border: solid 1px $color-regular-grey;
    font-size: $font-size-18px;
    /* color: $color-soft-grey; */
    color: $color-dark;
    box-shadow: none;
  }
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.academy-input.has-icons-left {
  .icon.is-left {
    left: 5px;
    top: 2px;
  }
}
</style>
